/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Repeater`)
};

const es_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const de_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textwiederholer`)
};

const nl_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstherhaler`)
};

const fr_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéteur de texte`)
};

const it_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetitore di testo`)
};

const pt_br2_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const pt_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const ja_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストリピーター`)
};

const zh_tr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本重复器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_nav_main", locale)
	if (locale === "en") return en_tr_nav_main(inputs)
	if (locale === "es") return es_tr_nav_main(inputs)
	if (locale === "de") return de_tr_nav_main(inputs)
	if (locale === "nl") return nl_tr_nav_main(inputs)
	if (locale === "fr") return fr_tr_nav_main(inputs)
	if (locale === "it") return it_tr_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_tr_nav_main(inputs)
	if (locale === "pt") return pt_tr_nav_main(inputs)
	if (locale === "ja") return ja_tr_nav_main(inputs)
	return zh_tr_nav_main(inputs)
};